var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[(_vm.show == true)?_c('form-preview',{attrs:{"type":_vm.type,"id":_vm.form_body_id,"form_id":_vm.form_id,"form_revision_id":_vm.form_revision_id,"taskId":_vm.task_id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }